<div class="change-language">
  <app-dialog
    [isShowDialog]="openChangeLanguageDialog()"
    [dialogTitle]="'change_language_dialog_title' | translate"
    [width]="'30%'"
    [closeIcon]="true"
    (handleCloseDialog)="resetLanguageForm()">
    <ng-container actions>
      <div class="change-language__choices">
        <app-radio-button
          class="change-language__choices-list"
          [label]="' '"
          [formGroup]="changeLanguageForm"
          [inputFormControlName]="'language_key'"
          [id]="'language_choice'"
          [options]="languagesList"
          [width]="'100%'"
          [border]="'1px solid var(--colors-neutral-200)'"
          [borderRadius]="'10px'" />
      </div>
      <app-button
        [id]="'change_language_dialog_submit_button_label'"
        [btnClasses]="'btn-small bg-primary-500 c-generic-white p-large'"
        [btnLabel]="'change_language_dialog_submit_button_label' | translate"
        [disabled]="isSubmitDisabled"
        (click)="changeLanguage()" />
    </ng-container>
  </app-dialog>
</div>
